import { useRef, useEffect } from 'react';
import { Coordinate } from '../dto/map/Coordinate';
import { Marker } from '../dto/map/Marker';

interface GoogleMapProps {
  className?: string,
  center: Coordinate,
  zoom: number,
  mainMarker?: Marker,
  otherMarkers?: Marker[],
  showIntrestPoints?: boolean,
  showTransitPoints?: boolean,
  onClickOtherMarkers?: (id: number) => void,
  mapHeight?: string
}

export default function GoogleMap(props: Readonly<GoogleMapProps>) {
  const {
    className,
    center,
    zoom,
    mainMarker,
    otherMarkers,
    showIntrestPoints = false,
    showTransitPoints = false,
    onClickOtherMarkers,
    mapHeight = '400px'
  } = props;

  const mapContainerRef = useRef(null);

  useEffect(() => {
    if (mapContainerRef.current) {
      const map = new google.maps.Map(mapContainerRef.current, {
        center: { lat: center.lat, lng: center.long },
        zoom: zoom,
        styles: [
          { featureType: "poi", stylers: [{ visibility: showIntrestPoints ? "on" : "off" }] },
          { featureType: "transit", stylers: [{ visibility: showTransitPoints ? "on" : "off" }] },
        ]
      });

      if (mainMarker) {
        const marker = new google.maps.Marker({
          position: { lat: mainMarker.position.lat, lng: mainMarker.position.long },
          map: map,
          icon: { url: mainMarker.icon, scaledSize: new google.maps.Size(25, 25) },
          title: mainMarker.title,
        });
        const infoWindow = new google.maps.InfoWindow({ content: mainMarker.title });
        marker.addListener("click", () => infoWindow.open(map, marker));
      }

      if (otherMarkers) {
        otherMarkers.forEach(marker => {
          const m = new google.maps.Marker({
            position: { lat: marker.position.lat, lng: marker.position.long },
            map: map,
            icon: { url: marker.icon, scaledSize: new google.maps.Size(25, 25) },
            title: marker.title,
          });
          const infoWindow = new google.maps.InfoWindow({ content: marker.title });
          m.addListener("click", () => {
            onClickOtherMarkers?.(marker.id);
            infoWindow.open(map, m);
          });
        });
      }
    }
  }, [center, zoom, mainMarker, otherMarkers]);

  return <div className={className} ref={mapContainerRef} style={{ height: mapHeight, width: '100%' }} />;
};
